import { AbstractDestroyable, Destructor } from '@deqo/foundation';
import { ClientRef, EventRouter, PodSessionWithRelayFeature } from '@deqo/podopolis';
import { Client } from './Client';
import { ClientManager } from './ClientManager';

export type CommuncationReceiver = (client: Client, data: any) => void;

export class Communicator extends AbstractDestroyable {

    private events = new EventRouter<Record<string, [Client, any]>>();

    constructor(private pod: PodSessionWithRelayFeature, private clients: ClientManager) {
        super();
        this.burden(pod.on('relay', this.onRelay));
    }

    public send(type: string, data: any);
    public send(to: string, type: string, data: any);

    public send(...args: any[]) {
        if (args.length === 2) args.splice(0, 0, '*');
        const [to, type, data] = args;
        this.pod.sendRelay(to, [type, data]);
    }

    public sendReduced(type: string, data: any, reductionKey: string);
    public sendReduced(to: string, type: string, data: any, reductionKey: string);

    public sendReduced(...args: any[]) {
        if (args.length === 2) args.splice(0, 0, '*');
        const [to, type, data, reductionKey] = args;
        this.pod.sendRelay(to, [type, data], reductionKey);
    }

    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    public recv(type: string | '*', callback: CommuncationReceiver): Destructor {
        return this.events.on(type, this.createAdapter(callback));
    }

    private createAdapter(callback: CommuncationReceiver) {
        return ([client, data]) => callback(client, data);
    }

    private onRelay = ([ci, data]: [ClientRef, any, string[]]) => {
        if (Array.isArray(data) && data.length === 2 && typeof data[0] === 'string') {
            this.events.emit(data[0], [this.clients.get(ci.id), data[1]]);
        }
    };

}
